import React from 'react';
import { ThemeProvider } from 'styled-components';
import { observer } from 'mobx-react-lite';
import Draggable from 'react-draggable'; // The default

import { ROUTES } from 'src/constants';
import { composeFullUrl } from 'src/helpers';
import { useStore } from '@src/models';
import { employerTheme } from 'src/theme';
import { BaseLink, Button } from 'src/kit';
import { Dropdown } from 'src/components';
import { StyledContainer } from './AdminActions.styled';

export const AdminActionsBar = observer(function AdminActionsBar() {
  const {
    routerStore: { companyDomain, isCompanyRoute },
    userStore: { user, isAdmin }
  } = useStore();

  if (!isAdmin && !user?.is_admin_logined_as) return null;

  return (
    <ThemeProvider theme={employerTheme}>
      <Draggable>
        <StyledContainer>
          <div style={{ height: '30px', width: '100%', cursor: 'move', padding: '5px 10px' }}>Move Widget</div>
          <StyledContainer style={{ position: 'static' }} onClick={e => e.stopPropagation()}>
            {isAdmin && <AdminActions {...{ user, companyDomain, isCompanyRoute }} />}
            {user?.is_admin_logined_as && <ReturnToAdminLink />}
          </StyledContainer>
        </StyledContainer>
      </Draggable>
    </ThemeProvider>
  );
});

const AdminActions = ({ user, isCompanyRoute, companyDomain }) => (
  <>
    {isCompanyRoute && (
      <>
        <BaseLink href={composeFullUrl(ROUTES.employer.companyProfile.base, companyDomain)}>Edit</BaseLink>
        <BaseLink href={composeFullUrl(ROUTES.employer.dashboard, companyDomain)}>Dashboard</BaseLink>
      </>
    )}
    <BaseLink href={ROUTES.admin.base} letterSpacing={1.1}>
      Admin panel
    </BaseLink>
    {(user?.admin_notifications_count || user?.admin_job_board_notifications_count) && (
      <Dropdown placement="left">
        <Dropdown.Toggle withCaret p="5px 10px" letterSpacing={1.1}>
          Notifications
        </Dropdown.Toggle>
        <Dropdown.Menu color="primary">
          {user?.admin_job_board_notifications_count && (
            <Dropdown.Item>
              <BaseLink href={ROUTES.admin.job_board_notifications}>
                Job Board Notifications {user.admin_job_board_notifications_count > 0 && '+'}{' '}
                {user?.admin_job_board_notifications_count}
              </BaseLink>
            </Dropdown.Item>
          )}
          {user?.admin_notifications_count && (
            <Dropdown.Item>
              <BaseLink href={ROUTES.admin.notifications}>
                Notifications {user.admin_notifications_count > 0 && '+'} {user?.admin_notifications_count}
              </BaseLink>
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    )}
  </>
);

const ReturnToAdminLink = () => (
  <BaseLink href={composeFullUrl(ROUTES.admin.return_to)} letterSpacing={1.1}>
    Return to admin
  </BaseLink>
);
